import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-relatorio-laudo-dados-veiculo',
  templateUrl: './relatorio-laudo-dados-veiculo.component.html',
  styleUrls: ['./relatorio-laudo-dados-veiculo.component.scss']
})
export class RelatorioLaudoDadosVeiculoComponent implements OnInit {

  @Input() template;

  imgMarcaVeiculo;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.setImgMarcaVeiculo();
  }

  setImgMarcaVeiculo() {
    if(this.template && this.template.elements) {
      let modelo = this.template.elements.find( e => e.name == "modelo" );
      let fabricante = this.template.elements.find( e => e.name == "fabricante" );
      if(modelo || fabricante) {
        let marca = fabricante.value || modelo.value.split("/")[0];
        this.imgMarcaVeiculo = 'https://s3-sa-east-1.amazonaws.com/siteunion/LAUDO/resources/marcas/' + marca + '.png';
      } else {
        this.imgMarcaVeiculo = '';
      }
    }
  }

}
